// Home Vuex

import state from './featureStates.js'
import * as getters from './featureGetters.js'
import * as mutations from './featureMutations.js'
import * as actions from './featureActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
